module.exports = __webpack_public_path__ + "img/pic-landing.5c0991af.png";